/* ============================================================
   Regulatory glossary
   ============================================================ */

export const GLOSSARY = {
  ACD: {
    term: 'Advance Cargo Declaration',
    definition:
      'A 15-digit reference that must appear on the Bill of Lading before a shipment is loaded at origin.',
    authority: 'KRA',
    related: ['kra-acd', 'eac-cma-2004']
  },
  AEO: {
    term: 'Authorised Economic Operator',
    definition:
      'Status granted by KRA to compliant traders, giving simplified procedures and reduced inspection rates.',
    authority: 'KRA',
    related: ['eac-cma-2004']
  },
  CB6: {
    term: 'Customs Bond Form 6',
    definition:
      'Security bond required of bonded warehouse operators, guaranteeing duty if goods are released improperly.',
    authority: 'KRA',
    related: ['kra-bonded-warehouse']
  },
  CFS: {
    term: 'Container Freight Station',
    definition:
      'A KPA-licensed facility for consolidating and deconsolidating containerised cargo away from the quay.',
    authority: 'KPA',
    related: ['kpa-tariff-2025']
  },
  CoC: {
    term: 'Certificate of Conformity',
    definition:
      'Issued by a KEBS-appointed inspection agency confirming goods meet Kenyan standards before export.',
    authority: 'KEBS',
    related: ['kebs-pvoc']
  },
  CVOL: {
    term: 'Commercial Vehicle Operator Licence',
    definition:
      'Operator-level NTSA licence covering fitness, safety management and a nominated safety officer.',
    authority: 'NTSA',
    related: ['ntsa-cvol']
  },
  CVRL: {
    term: 'Commercial Vehicle Road Licence',
    definition: 'Annual per-vehicle NTSA licence. Fee: KSh 2,000 per vehicle per year.',
    authority: 'NTSA',
    related: ['ntsa-cvrl']
  },
  Demurrage: {
    term: 'Demurrage',
    definition:
      'Charge accruing when a container remains at the terminal beyond its free period. Distinct from detention, which is the charge for holding the carrier’s equipment after gate-out.',
    authority: 'KPA / carrier',
    related: ['kpa-tariff-2025']
  },
  Detention: {
    term: 'Detention',
    definition:
      'Charge accruing when the carrier’s container is held after leaving the terminal and before return.',
    authority: 'Carrier',
    related: ['kpa-tariff-2025']
  },
  EAC: {
    term: 'East African Community',
    definition:
      'Regional bloc comprising Kenya, Tanzania, Uganda, Rwanda, Burundi, South Sudan, DRC and Somalia.',
    authority: 'EAC',
    related: ['eac-cma-2004', 'eac-ntb-act']
  },
  GLEC: {
    term: 'Global Logistics Emissions Council Framework',
    definition:
      'The methodology for accounting freight greenhouse gas emissions across all modes, now aligned with ISO 14083:2023.',
    authority: 'Smart Freight Centre',
    related: []
  },
  ICD: {
    term: 'Inland Container Depot',
    definition:
      'A dry port for container handling, customs clearance and storage away from the seaport.',
    authority: 'KPA',
    related: ['kpa-tariff-2025']
  },
  IDF: {
    term: 'Import Declaration Form',
    definition: 'Filed with KRA before goods arrive. Fee: 2.5% of CIF value, reduced from 3.5% in 2023.',
    authority: 'KRA',
    related: ['idf-2-5pc']
  },
  iCMS: {
    term: 'Integrated Customs Management System',
    definition:
      'KRA’s electronic platform for declarations, risk profiling, assessment, release and post-clearance audit.',
    authority: 'KRA',
    related: ['kra-icms']
  },
  'ISO 14083': {
    term: 'ISO 14083:2023',
    definition:
      'The international standard for quantifying and reporting greenhouse gas emissions from transport chain operations.',
    authority: 'ISO',
    related: []
  },
  NTB: {
    term: 'Non-Tariff Barrier',
    definition:
      'A trade restriction other than a tariff — quotas, licensing demands, ad hoc fees or bureaucratic delay. Reportable at tradebarriers.africa.',
    authority: 'EAC / AfCFTA',
    related: ['eac-ntb-act']
  },
  PVoC: {
    term: 'Pre-Export Verification of Conformity',
    definition:
      'Mandatory inspection of regulated goods at origin by a KEBS-appointed agency before shipment to Kenya.',
    authority: 'KEBS',
    related: ['kebs-pvoc']
  },
  RDL: {
    term: 'Railway Development Levy',
    definition: 'Levy on imports funding railway infrastructure. Raised to 2% of CIF in 2024, from 1.5%.',
    authority: 'KRA',
    related: ['rdl-2pc']
  },
  SGR: {
    term: 'Standard Gauge Railway',
    definition:
      'Kenya’s 472 km Mombasa–Nairobi railway, extended to Naivasha. Cumulative freight passed 50 million tonnes in July 2026.',
    authority: 'KRC',
    related: []
  },
  TEU: {
    term: 'Twenty-foot Equivalent Unit',
    definition: 'Standard unit of container capacity, equal to one 20-foot container.',
    authority: 'ISO',
    related: []
  }
};

export function getTerm(key) {
  return Object.prototype.hasOwnProperty.call(GLOSSARY, key) ? GLOSSARY[key] : null;
}

export function searchGlossary(query) {
  const q = String(query || '').toLowerCase().trim();
  const entries = Object.entries(GLOSSARY).map(([key, entry]) => ({ key, ...entry }));
  if (!q) return entries;
  return entries.filter(
    (e) =>
      e.key.toLowerCase().includes(q) ||
      e.term.toLowerCase().includes(q) ||
      e.definition.toLowerCase().includes(q)
  );
}
